enum SurveyResponseActionType {
  REFUND = 'REFUND',
  CANCEL = 'CANCEL',
}

/**
 * @deprecated This type is only used within the refund bundle. Please move it to that bundle.
 */
export default SurveyResponseActionType;
